import { Flex } from '@chakra-ui/react';
import { useLocalization } from '~/framework';
import { SearchForm } from '~/ui-components';
import { useQuizSessionsContext } from '../QuizSessionsContext';

export function SearchBar() {
   const { _js } = useLocalization();

   const { queryFormValue, setQueryFormValue } = useQuizSessionsContext();

   return (
      <Flex flex={1} justifyContent={'flex-end'}>
         <SearchForm
            name="search-quiz-sessions"
            w={340}
            value={queryFormValue}
            onChange={ev => setQueryFormValue(ev.target.value)}
            placeholder={_js('Search')}
         />
      </Flex>
   );
}
